<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllReport()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkUserShop() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="branchList"
                label="Select Branch"
                v-model="queryParams.branchId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkUserBranch() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="departmentList"
                label="Select Department"
                v-model="queryParams.departmentId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Machine Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="maintenanceFrequencyList"
                label="Select Maintenance Frequency"
                v-model="queryParams.maintenanceFrequencyId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                v-model="queryParams.machineTypeIds"
                :items="machineTypeList"
                color="blue-grey lighten-2"
                label="Select Machine Type"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="preventiveMaintenanceMachineReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.machineName }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>
                <span
                  v-for="(header, index) in props.item.deviceList"
                  :key="index"
                  >{{ header }}<br
                /></span>
              </td>
              <td>{{ props.item.maintenanceFrequencyName }}</td>
              <td>{{ props.item.remark }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all format-->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px; display: none"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Preventive Maintenance Machine Report
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
          "
        >
          <thead>
            <tr>
              <th style="border: 1px solid black; text-align: center">No</th>
              <th style="border: 1px solid black; text-align: center">
                Machine Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Department
              </th>
              <th style="border: 1px solid black; text-align: center">
                Location(Device Name)/Work Description
              </th>
              <th style="border: 1px solid black; text-align: center">
                Maintenance Frequency
              </th>
              <th style="border: 1px solid black; text-align: center">
                Remark
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(
              machineReport, index
            ) in allPreventiveMaintenanceMachineReportList"
            :key="index"
          >
            <tr v-for="(item, i) in machineReport.reportList" :key="i">
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border:1px solid black;'
                    : 'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
                v-if="i == 0"
              >
                {{ machineReport.no }}
              </td>
              <td
                style="
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  text-align: left;
                "
                v-else
              ></td>
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border:1px solid black;'
                    : 'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
                v-if="i == 0"
              >
                {{ item.machineName }}
              </td>
              <td
                style="
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  text-align: left;
                "
                v-else
              ></td>
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border:1px solid black;'
                    : 'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
                v-if="i == 0"
              >
                {{ item.departmentName }}
              </td>
              <td
                style="
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  text-align: left;
                "
                v-else
              ></td>
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;'
                    : 'border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
              >
                <span v-for="(header, j) in item.deviceList" :key="j">
                  -{{ header }}<br />
                </span>
              </td>
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border:1px solid black;'
                    : 'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
                v-if="i == 0"
              >
                {{ item.maintenanceFrequencyName }}
              </td>
              <td
                style="
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  text-align: left;
                "
                v-else
              ></td>
              <td
                :style="
                  i == machineReport.reportList.length - 1
                    ? 'border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;'
                    : 'border-left:1px solid black;border-right:1px solid black;text-align:left;'
                "
              >
                {{ item.remark }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { preventiveMaintenanceMachineReportService } from "../../services/preventive-maintenance-machine-service";
import { shopService } from "../../services/shop-service";
import { branchService } from "../../services/branch-service";
import { departmentService } from "../../services/department-service";
import { maintenanceFrequencyService } from "../../services/maintenance-frequency-service";
import { machineTypeService } from "../../services/machine-type-service";

export default {
  name: "PreventiveMaintenanceMachineReport",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Preventive Maintenance Machine Report",
        disabled: true,
      },
    ],
    statusList: [
      { label: "---All---", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
      { label: "SERVICEABLE", value: "SERVICEABLE" },
    ],
    headers: [
      { text: "Machine Name", align: "left", sortable: false },
      { text: "Department", sortable: false },
      { text: "Location(Device Name)/Work Description", sortable: false },
      { text: "Maintenance Frequency", sortable: false },
      { text: "Remark", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    queryParams: {
      shopId: "",
      branchId: "",
      departmentId: "",
      name: "",
      maintenanceFrequencyId: "",
      status: "",
      machineTypeIds: [],
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0,
    },
    shopList: [],
    branchList: [],
    departmentList: [],
    maintenanceFrequencyList: [],
    preventiveMaintenanceMachineReportList: [],
    allPreventiveMaintenanceMachineReportList: [],
    machineTypeList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getPreventiveMaintenanceMachineReport();
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.branchId) {
      this.queryParams.branchId = this.$route.query.branchId;
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = this.$route.query.departmentId;
    }
    if (this.$route.query.name) {
      this.queryParams.name = this.this.$route.query.name;
    }
    if (this.$route.query.maintenanceFrequencyId) {
      this.queryParams.maintenanceFrequencyId =
        this.$route.query.maintenanceFrequencyId;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.queryParams.shopId = this.checkUserShop();
    this.queryParams.branchId = this.checkUserBranch();

    this.getAllShop();
    this.getActiveBranchList();
    this.getActiveDepartmentList();
    this.getActiveMaintenanceFrequencyList();
    this.getActiveMachineTypeList();
  },
  methods: {
    checkUserShop() {
      if (this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
        return "";
      // }
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "----All----" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
          this.branchList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveMachineTypeList() {
      machineTypeService
        .getMachineTypeByStatus("ACTIVE")
        .then((res) => {
          this.machineTypeList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveMaintenanceFrequencyList() {
      maintenanceFrequencyService
        .getMaintenanceFrequencyByStatus("ACTIVE")
        .then((res) => {
          this.maintenanceFrequencyList = res.data;
          this.maintenanceFrequencyList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "preventive-maintenance-machine-report",
        query: this.queryParams,
      });
      this.getPreventiveMaintenanceMachineReport();
    },
    getPreventiveMaintenanceMachineReport() {
      this.showListLoading = true;
      preventiveMaintenanceMachineReportService
        .getPreventiveMaintenanceMachineReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this.preventiveMaintenanceMachineReportList = res.data.reportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllReport() {
      this.buttonLoading = true;
      preventiveMaintenanceMachineReportService
        .exportPreventiveMaintenanceMachineReportExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    printAllReport(divName) {
      this.buttonLoading = true;
      preventiveMaintenanceMachineReportService
        .printPreventiveMaintenanceMachineReport(this.queryParams)
        .then((res) => {
          this.allPreventiveMaintenanceMachineReportList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>
